// extracted by mini-css-extract-plugin
module.exports = {"codeContainer":"code-container-module--code-container--21XH7"};